import React from "react";
import { useNavigate } from "react-router-dom";
import { Phone, ChevronDown, User } from "lucide-react";
import { MobileNumberSwitcher } from "@/components/mobile/MobileNumberSwitcher";
import { useNumbers } from "@/context/NumberContext";
import { useAuth } from "@/context/AuthContext";

export const MobileTopBar = () => {
  const { selectedNumber } = useNumbers();
  const { isAdmin } = useAuth();
  const navigate = useNavigate();

  return (
    <header
      data-testid="mobile-topbar"
      className="md:hidden sticky top-0 z-30 bg-white/95 backdrop-blur border-b border-slate-200 h-14 flex items-center justify-between px-3"
    >
      <MobileNumberSwitcher
        trigger={
          <button
            data-testid="mobile-switcher-trigger"
            className="flex items-center gap-2 rounded-lg px-2 py-1.5 active:bg-slate-100 max-w-[72vw]"
          >
            <span className="h-8 w-8 rounded-lg bg-emerald-600 flex items-center justify-center shrink-0">
              <Phone className="h-4 w-4 text-white" strokeWidth={2.4} />
            </span>
            <span className="min-w-0 leading-tight text-left">
              <span className="block text-sm font-semibold text-slate-900 truncate">
                {selectedNumber?.line_name || "Toutes les lignes"}
              </span>
              <span className="block text-[11px] text-slate-400 tabular-nums truncate">
                {selectedNumber?.number || "Les deux numéros"}
              </span>
            </span>
            <ChevronDown className="h-4 w-4 text-slate-400 shrink-0" />
          </button>
        }
      />

      <button
        data-testid="mobile-account-btn"
        onClick={() => navigate(isAdmin ? "/parametres" : "/mon-poste")}
        className="h-10 w-10 rounded-full bg-slate-100 border border-slate-200 flex items-center justify-center text-slate-600 active:bg-slate-200 shrink-0"
        aria-label={isAdmin ? "Compte et paramètres" : "Mon poste et compte"}
      >
        <User className="h-5 w-5" />
      </button>
    </header>
  );
};
